export default "__VITE_PUBLIC_ASSET__c3407f4d__"